import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import MonthlyReport from '@app/views/Ledger/MonthlyReport';
import { memo } from 'react';

export default memo(
  withIfUser(MonthlyReport)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
